import styles from './pursuit.module.css'

/**
 * THE SUBMIT LINK — a record's official channel to participate.
 *
 * An RFP a rep can't actually bid on is useless, so wherever a pursuit row is
 * surfaced (kanban card, gaps table, detail drawer) its solicitation /
 * submission URL is a real, clickable link out to the official channel.
 *
 * Renders NOTHING when the record has no URL — the honest empty state for a
 * link belongs in the drawer, where it can say so in words, not as a dead
 * button on a card. The URL is already protocol-checked by `safeUrl()` in the
 * adapter; this never builds one from a fragment.
 *
 * `stopPropagation` because these live inside click-to-open rows and cards: the
 * link must open the official listing, not the drawer behind it.
 */
export default function SubmitLink({ record, variant = 'chip' }) {
  const url = record?.sourceUrl
  if (!url) return null
  const label = record.submitLabel || 'Open official listing'
  return (
    <a
      className={variant === 'button' ? styles.submitBtn : styles.submitChip}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={`${label} — opens ${url} in a new tab`}
    >
      {label}
      <span aria-hidden="true"> ↗</span>
    </a>
  )
}
